import { observer } from 'mobx-react';

import CollectionPreview from '@/collection/components/CollectionPreview/CollectionPreview';
import Icon from '@/common/components/Icon/Icon';
import AppSectionTreeItem from '@/drive/entities/DriveTreeItem/AppSectionTreeItem';
import { CollectionTreeItem } from '@/drive/entities/DriveTreeItem/CollectionTreeItem';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { FolderTreeItem } from '@/drive/entities/DriveTreeItem/FolderTreeItem';
import { DriveSection } from '@/drive/types/DriveSection';

import styles from './DriveModalTreeItemPreview.module.css';

export interface DriveModalTreeItemPreviewProps {
  item: DriveTreeItem;
}

function DriveModalTreeItemPreview(props: DriveModalTreeItemPreviewProps) {
  const { item } = props;

  if (item instanceof FolderTreeItem) {
    return <Icon name="folder" className={styles.icon} />;
  }

  if (item instanceof CollectionTreeItem) {
    return (
      <CollectionPreview
        collectionId={item.collectionId}
        containerSize={46}
        gap={2}
        isBordered
        isRenderLabelExpandable={false}
      />
    );
  }

  if (item instanceof AppSectionTreeItem && item.id === DriveSection.DriveRoot) {
    return <Icon name="cutwise-drive" className={styles.icon} />;
  }

  return null;
}

export default observer(DriveModalTreeItemPreview);
